/**
 * @author Andy Lemaire
 */
import $ from 'jquery';
import createLogger from 'components/logger/Logger';

const Logger = createLogger('ContactCategories');
export default class ContactCategories {
  constructor(options) {
    this.options = options;
    this.initialize();
  }

  initialize() {
    this.$categorySelector = $(this.options.categorySelector);
    this.$subCategorySelector = $(this.options.subCategorySelector);
    this.$webshopSubcategorySelector = $('[data-category="webshop"] select');
    this.bindEvents();
  }

  bindEvents() {
    this.$categorySelector.on('change', event => this.onChange(event));
    this.$webshopSubcategorySelector.on('change', this.handleFormTransformation.bind(this));
  }

  hideElement(element) {
    element?.classList?.add('is-hidden');
  }

  showElement(element) {
    element?.classList?.remove('is-hidden');
  }

  handleFormTransformation(event) {
    const { name, value } = event.currentTarget;

    if (name === 'category') {
      this.$selectedCategoryValue = value;
    }

    if (name === 'subCategory') {
      this.$selectedSubCategoryValue = value;
    }

    if (
      this.$selectedCategoryValue === 'webshop' &&
      this.$selectedSubCategoryValue === 'gdpr-request'
    ) {
      this.form = this.$webshopSubcategorySelector?.[0]?.form;

      if (!this.form) return;

      this.formInputs = this.form.querySelectorAll('.formInputGroup-text');
      this.submitButton = this.form.querySelector('#submitBtn');
      this.nextButton = this.form.querySelector('#nextBtn');
      this.textareas = this.form.querySelectorAll('.formInputGroup--textarea');
      this.recaptcha = this.form.querySelector('#recaptcha-container');

      this.formInputs.forEach(this.hideElement);
      this.textareas.forEach(this.hideElement);
      this.hideElement(this.submitButton);
      this.hideElement(this.recaptcha);
      this.showElement(this.nextButton);
      this.nextButtonIsShown = true;
    } else if (this.nextButtonIsShown) {
      this.formInputs.forEach(this.showElement);
      this.textareas.forEach(this.showElement);
      this.showElement(this.submitButton);
      this.showElement(this.recaptcha);
      this.hideElement(this.nextButton);
      this.nextButtonIsShown = false;
    }
  }

  onChange(event) {
    const { value } = event.currentTarget;

    this.handleFormTransformation(event);

    this.$selectedCategory = $(`[data-category="${value}"]`);

    this.$subCategorySelector.addClass('is-hidden').find('select').prop('disabled', true);

    this.$selectedCategory.removeClass('is-hidden').find('select').prop('disabled', false);
  }
}
